import React from "react";
import ScriptClaimStatusView from "../../Script/views/ClaimStatusView.jsx";

export default function AmmendClaimStatusView(props) {
  return <ScriptClaimStatusView {...props} />;
}
